// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__22sZb","filesListContainer":"PosDisputesFiles_filesListContainer__2Gs_t","filesButton":"PosDisputesFiles_filesButton__1NNUR"};